import React, {useEffect, useState} from "react";
import { Link } from 'react-router-dom';
import {Col} from "react-bootstrap";
import ApiService from "../../services/ApiService";
import DateTimeUtils from "../../services/DateTimeUtils";

function CardHome({ id, title, piscinaId, price, noOfLessons, levelCourseId, start}){

    const [piscina, setPiscina] = useState();
    const [level, setLevel] = useState();
    const [imageUrl, setImageUrl] = useState();


    useEffect(() => {
        console.log("PiscinaId: " + piscinaId)
        ApiService.getPoolById(piscinaId)
            .then(piscinaData => setPiscina(piscinaData))
        ApiService.getLevelById(levelCourseId)
            .then(level => {
                getImageByLevel(level)
                setLevel(level)
            })

        return () => {setPiscina(undefined); setLevel(undefined); setImageUrl(undefined)}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const getImageByLevel = (level) => {
        ApiService.getLevelImageById(getIdByLevel(level)).then(image => {
            if(image.ok){
                image.blob().then(imageBlob => {
                    const url = URL.createObjectURL(imageBlob);
                    setImageUrl(url);
                })
            }
        })
    }

    const getIdByLevel = (level) => {
        switch (level.level) {
            case "PRINC":
                return 0;
            case "LIV 7":
                return 7;
            case "LIV 6":
                return 6;
            case "LIV 5":
                return 5;
            case "LIV 4":
                return 4;
            case "LIV 3":
                return 3;
            case "LIV 2":
                return 2;
            case "LIV 1":
                return 1;
            case "LIV 0":
                return 0;
            default:
                return null; // Return null or any appropriate value if the level is not found
        }
    }

    return (
        <Link to={'/shop/course/'+ id} className="card card-course row g-0">
            <Col xs={12} xl={6}>
                <div className="card-image">
                    {imageUrl ? (
                            <img alt={"levelImage"} src={imageUrl} className={"course-001"} />
                        ) :
                        <img alt={'levelImage'} src={'https://images.unsplash.com/photo-1600965962361-9035dbfd1c50?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2370&q=80'} className={'course-001'}/>
                    }

                </div>
            </Col>
            <Col xs={12} xl={6}>
                <div className="card-body">
                    <h5 className="card-title">{title} {piscina && piscina.title}, {level && level.level}</h5>
                    <div className="card-information">
                        <div className="card-duration">
                            <p>
                                Periodo di svolgimento: <br/>
                                dal {DateTimeUtils.formatStartStringAsDate(start)} {/*al 09.01.23*/}<br/>
                                {noOfLessons} lezioni
                            </p>
                        </div>
                    </div>
                    <div className="d-flex mt-auto justify-content-between align-items-center">
                        <div className={'card-price'}>
                            {parseFloat(price).toFixed(2)} CHF
                        </div>
                        <svg viewBox="0 0 72.7 59.6" className="btn btn-card">
                            <g>
                                <path className="st0" d="M35.6,52.3l16-15.4c-3.4,1.3-6.9,1.9-10.6,1.9c-3.1,0-5.9-0.4-8.4-1.1c-2.5-0.7-5.3-1.8-8.4-3.1
                                            c-2.7-1.1-4.7-1.9-6.2-2.4c-1.5-0.5-3-0.7-4.7-0.7C8.5,31.5,4.1,33.3,0,37V25.7c3.7-3.3,8.1-4.9,13.3-4.9c2.2,0,4.2,0.3,6,0.8
                                            c1.8,0.5,4.1,1.4,7,2.6c2.8,1.3,5.3,2.2,7.4,2.9c2.2,0.6,4.6,1,7.2,1c4.5,0,8.8-1.1,12.7-3.4L35.6,7.2L42.8,0l29.9,29.8L42.8,59.6
                                            L35.6,52.3z"/>
                            </g>
                        </svg>
                    </div>
                </div>
            </Col>
        </Link>
    )
}
export default CardHome;